export default __webpack_public_path__ + "static/integrations-4c9af62874c1fbea724e3add368ba89d.png";